import { z } from 'zod/v4';

import { endpoint } from '../http/endpoint';
import { AssemblyIdRuntype } from '../idTypes';
import { ManufacturingSourcingCacheLastRefreshRuntime } from './manufacturingSourcingCacheBackendTypes';

export const manufacturingSourcingCacheEndpoints = {
    'GET /manufacturing-cache/sourcing/last_refresh/:assemblyId': endpoint({
        description: "Get the timestamp when the assembly's sourcing cache was last refreshed",
        pathParams: z.object({ assemblyId: AssemblyIdRuntype }),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: ManufacturingSourcingCacheLastRefreshRuntime,
        actionPermission: () => 'CanViewManufacturingInRfQ',
    }),
    'POST /manufacturing-cache/sourcing/refresh/:assemblyId': endpoint({
        description: 'Refresh the sourcing cache for the assembly',
        pathParams: z.object({ assemblyId: AssemblyIdRuntype }),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: z.unknown(),
        invalidates: [
            'GET /manufacturing-assembly-details/:manufacturingAssemblyDetailsId/overview',
            'GET /calculations/calculation-assembly-costs',
            'GET /manufacturing-cache/sourcing/last_refresh/:assemblyId',
        ],
        actionPermission: () => 'CanUpdateManufacturingInRfQ',
    }),
};
